import color from './color.js'
import gradient from './gradient.js'
import theme from './theme.js'
import font from './font.js'
import font_family from './font_family.js'
import typography from './typography.js'
import spacing from './spacing.js'
import timing from './timing.js'
import class_ from './class.js'
import grid from './grid.js'
import icons from './icons.js'
import shape from './shape.js'
import reset from './reset.js'
import animation from './animation.js'
import media from './media.js'

export default {
  color,
  gradient,
  theme,
  font,
  font_family,
  typography,
  spacing,
  timing,
  class: class_,
  grid,
  icons,
  shape,
  reset,
  animation,
  media,
}
